import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import ForkliftEstimatesWrapper from "@components/layouts/forkliftestimatesWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function FreeCreditEvaluationHome(): ReactElement {
    return (
        <ForkliftEstimatesWrapper>
            <PrivacyPolicy
                category="Forklifts"
                domain="forkliftestimates.com"
            />
        </ForkliftEstimatesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
